import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PerimeterDto } from '../shared/models/perimeter.dto';
import { BeneficiariesService } from '../shared/services/beneficiaries.service';

@Directive({
  selector: '[appProfilePerimeter]',
  standalone: false,
})
export class ProfilePerimeterDirective implements OnInit, OnDestroy {
  private readonly destroy$: Subject<void> = new Subject();
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly beneficiariesService: BeneficiariesService,
  ) {}
  public ngOnInit(): void {
    this.beneficiariesService.perimeter.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((perimeter: PerimeterDto) => {
      let hasAccess: boolean = false;
      if (perimeter && perimeter.canAccess && perimeter.canEdit) {
        hasAccess = true;
      }

      if (hasAccess) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
